import loadable from '@loadable/component';

// the adyen library is quite large so we only want to load the
// travelpass/uatp form if a user really needs it
const AsyncUatpForm = loadable(() => import(/* webpackPrefetch: true */ './UatpForm'));

AsyncUatpForm.displayName = 'AsyncUatpForm';

export default AsyncUatpForm;
